import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "react-toastify/dist/ReactToastify.css";

import { enableMapSet } from "immer";
import { AppProviders } from "./AppProviders";

enableMapSet();

//COMMENTED FOR DEVELOPMENT PURPOSES//
if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_API_MOCK === "true"
) {
  const { worker } = require("./mocks/browser");
  worker.start();
}

ReactDOM.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
